/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { fonts } from '@blend/consumer-components';
import { Card } from '@components/Card/Card';
import JournalPrincipalSignature from '@components/Journal/JournalPrincipalSignature';

export interface CardInfoItem {
  primary: string;
  value: string;
}
export namespace InfoCard {
  export interface Props extends React.HTMLAttributes<HTMLDivElement> {
    cardInfo: CardInfoItem[];
  }
}

const styles = StyleSheet.create({
  table: {
    width: '100%',
  },
  tableBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    width: '100%',
  },
  row: {
    display: 'flex',
    width: '100%',
  },
  primaryWrapper: {
    width: '40%',
    fontWeight: fonts.weight.book,
  },
  valueWrapper: {
    width: '60%',
    fontWeight: fonts.weight.bold,
    wordWrap: 'break-word',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
});

export const InfoCard: React.SFC<InfoCard.Props> = ({ cardInfo }) => {
  // TODO cardInfo is defined as an Array-like, but the instances of InfoCard in parent components
  //  potentially use an any type, which means that TypeScript doesn't know that it's not getting passed
  //  a parameter value with a proper type.
  return (
    <Card>
      <table className={css(styles.table)} aria-label={`information table`}>
        <tbody className={css(styles.tableBody)}>
          {cardInfo?.map(infoItem => {
            if (infoItem.primary === 'signatureFileBase64') {
              return <JournalPrincipalSignature signatureMetadata={{ fileBase64: infoItem.value }} />;
            }
            return (
              <tr key={infoItem.primary} className={css(styles.row)}>
                <th className={css(styles.primaryWrapper)} title={infoItem.primary} data-it="infoItem-primary">
                  {infoItem.primary}
                </th>
                <td className={css(styles.valueWrapper)} title={`${infoItem.value}`} data-it="infoItem-value">
                  {infoItem.value}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </Card>
  );
};
